var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#005DAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2192 8H10C8.89543 8 8 8.89543 8 10V12C8 17.5228 12.4772 22 18 22H20C21.1046 22 22 21.1046 22 20V18.618C22 18.2393 21.786 17.893 21.4472 17.7236L19.0313 16.5156C18.487 16.2435 17.8278 16.5165 17.6354 17.0938L17.3376 17.9871C17.1447 18.5658 16.5512 18.9102 15.9531 18.7906C13.5593 18.3119 11.6881 16.4407 11.2094 14.0469C11.0898 13.4488 11.4342 12.8553 12.0129 12.6624L13.1215 12.2928C13.6172 12.1276 13.9021 11.6086 13.7754 11.1016L13.1894 8.75746C13.0781 8.3123 12.6781 8 12.2192 8Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.baf140a878199e27b3692e0f519e6d65.svg";
export { ForwardRef as ReactComponent };